import { ChainId } from '@uniswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]?: string } = {
  [ChainId.TURING]: '0x2A5A30d005c6bB87A6944d220E41B6c1C8412183'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
